var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',{attrs:{"color":"secondary"}},[_c('v-tab',[_vm._v("Users")]),_c('v-tab-item',[_c('Users')],1),_c('v-tab',[_vm._v("Divisions")]),_c('v-tab-item',[_c('Divisions')],1),_c('v-tab',[_vm._v("Import Bills")]),_c('v-tab-item',[_c('ImportBills')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }